export default __webpack_public_path__ + "static/coworking-5b72e16e0a50fa906f21b4e6b0a5b056.jpg";